import { render } from "./LakeviewParameters.vue?vue&type=template&id=0ca360c0&scoped=true"
import script from "./LakeviewParameters.vue?vue&type=script&lang=js"
export * from "./LakeviewParameters.vue?vue&type=script&lang=js"

import "./LakeviewParameters.vue?vue&type=style&index=0&id=0ca360c0&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca360c0"]])

export default __exports__